import React from "react";
import "./CustomRequests.css";
import {Accordion} from "react-bootstrap";
import CustomRequest from "./CustomRequest";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faComments} from "@fortawesome/free-regular-svg-icons";

function CustomRequests({bondApi}) {
    return <Accordion id="customRequestsAccordion">
        <Accordion.Item eventKey="0">
            <Accordion.Header><FontAwesomeIcon icon={faComments} size="xl" className="iconAccordionHeader"/>Custom
                Request</Accordion.Header>
            <CustomRequest bondApi={bondApi}/>
        </Accordion.Item>
    </Accordion>;
}

export default CustomRequests;
